import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentMessageFeedbackSubmitted.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type AgentMessageFeedbackSentiment = 'thumbs_down' | 'thumbs_up';

export type UseTrackAgentMessageFeedbackSubmittedParams = {
  message_id: string;
  sentiment: AgentMessageFeedbackSentiment;
  session_id: string;
};

export const useTrackAgentMessageFeedbackSubmitted = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentMessageFeedbackSubmitted = useCallback(
    (params: UseTrackAgentMessageFeedbackSubmittedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentMessageFeedbackSubmitted };
};
